import React from 'react';

export interface PaginationProps {
  currentPage: number;
  totalPages?: number;
  hasNext?: boolean;
  hasPrevious?: boolean;
  onPageChange: (page: number) => void;
  className?: string;
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  hasNext = true,
  hasPrevious = currentPage > 1,
  onPageChange,
  className = ''
}) => {
  const handlePrevious = () => {
    if (hasPrevious) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (hasNext) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <button
        onClick={handlePrevious}
        disabled={!hasPrevious}
        className={`px-4 py-2 text-sm font-medium rounded-lg border transition-colors ${
          hasPrevious
            ? 'border-gray-300 text-gray-700 hover:bg-gray-50'
            : 'border-gray-200 text-gray-400 cursor-not-allowed'
        }`}
      >
        Previous
      </button>

      <span className="px-4 py-2 text-sm text-gray-700">
        Page {currentPage}{totalPages ? ` of ${totalPages}` : ''}
      </span>

      <button
        onClick={handleNext}
        disabled={!hasNext}
        className={`px-4 py-2 text-sm font-medium rounded-lg border transition-colors ${
          hasNext
            ? 'border-gray-300 text-gray-700 hover:bg-gray-50'
            : 'border-gray-200 text-gray-400 cursor-not-allowed'
        }`}
      >
        Next
      </button>
    </div>
  );
};
